import { LOGOUT_URL } from '../config';

export const logout = async () => {
  try {
    // Redirect the user to the logout URL
    window.location.href = LOGOUT_URL;
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.error('Error during logout:', error);
    throw error;
  }
};
